module.exports = __webpack_public_path__ + "static/media/20ECE19.3472a9f6.jpg";